import store from './configureStore';
import StoreRegistry from './storeRegistry';

export { store, StoreRegistry };
